import React, { useEffect } from 'react';
import CookieConsent from '../components/CookieConsent';
import { Header } from '../components/shared/Header';
import { Footer } from '../components/shared/Footer';
import { HerancasHero } from '../components/herancas/HerancasHero';
import { HerancasContextSection } from '../components/herancas/HerancasContextSection';
import { LegalFrameworkSection } from '../components/herancas/LegalFrameworkSection';
import { HerancasRoleSection } from '../components/herancas/HerancasRoleSection';
import { ApplicabilitySection } from '../components/herancas/ApplicabilitySection';
import { HerancasFiscalSection } from '../components/herancas/HerancasFiscalSection';
import { HerancasProcessSection } from '../components/herancas/HerancasProcessSection';
import { AdvantagesSection } from '../components/herancas/AdvantagesSection';
import { HerancasFAQSection } from '../components/herancas/HerancasFAQSection';
import { HerancasCTASection } from '../components/herancas/HerancasCTASection';
import { herancasSchemas } from '../lib/herancasSchemas';
import { useSeo } from '../lib/seo';
import '../App.css';

const NAV_ITEMS = [
  { label: 'Serviços', href: '/#servicos' },
  { label: 'Sobre', href: '/#sobre' },
  { label: 'Heranças', href: '/herancas' },
  { label: 'Contacto', href: '#contacto-herancas' }
];

function Herancas() {
  useSeo({
    title: 'Avaliação de Imóveis para Heranças e Partilhas · Perito CMVM · Valuare JR',
    description:
      'A partilha está parada à espera do valor do imóvel? Relatório por Perito CMVM, aceite por notários e tribunais, em 5 a 8 dias úteis. Proposta hoje.',
    url: 'https://valuarejr.com/herancas'
  });

  // Inject JSON-LD schemas into document head (cleaned up on unmount)
  useEffect(() => {
    const scriptElements = herancasSchemas.map((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      scriptElements.forEach((script) => {
        if (script.parentNode) script.parentNode.removeChild(script);
      });
    };
  }, []);

  return (
    <div className="valuare-app">
      <div className="herancas-page">
      <Header navItems={NAV_ITEMS} />
      <HerancasHero />
      <HerancasContextSection />
      <LegalFrameworkSection />
      <HerancasRoleSection />
      <ApplicabilitySection />
      <HerancasFiscalSection />
      <HerancasProcessSection />
      <AdvantagesSection />
      <HerancasFAQSection />
      <HerancasCTASection />
      <Footer />
      </div>
      <CookieConsent />
    </div>
  );
}

export default Herancas;
